// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"productImageSmallThumbnail_Tabs__2yDtE"};